import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingScreen = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "95vh",
      flexDirection: "column",
      gap: "20px",
    }}
  >
    <CircularProgress size={60} />
    <div>Loading map data...</div>
  </div>
);

export default LoadingScreen;